import axios from 'axios';
import { notifications } from '@mantine/notifications';
import { ErrorResponse } from './responses/error-response.ts';

export type AuthHandlers = {
  promptLogin?: () => void;
  goForbidden?: () => void;
};

let handlers: AuthHandlers = {};

export const setAuthHandlers = (h: AuthHandlers) => {
  handlers = h;
};

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    switch (status) {
      case 401:
        handlers.promptLogin?.();
        break;
      case 403:
        handlers.goForbidden?.();
        break;
      case 422: {
        const errorResponse: ErrorResponse = {
          code: error.response!.data!.error!.code,
          message: error.response!.data!.error!.message,
        };

        return Promise.reject(errorResponse);
      }
      default: {
        const message =
          error.response?.data?.error?.message || '發生錯誤，請稍後再試';
        notifications.show({
          title: '發生錯誤',
          message,
          color: 'red',
        });
        return Promise.reject(error);
      }
    }
  },
);
